module.exports = __webpack_public_path__ + "static/media/facebook.cc93ace3.svg";